import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-expense-amount-block',
  templateUrl: './expense-amount-block.component.html',
  styleUrls: ['./expense-amount-block.component.scss'],
  standalone: false
})
export class ExpenseAmountBlockComponent {
  @Input() pending!: string | number;
  @Input() pay!: string | number;
  @Input() total!: string | number;
}
